import debounce from '../helpers/debounce';

/**
 * StickyFooter
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.config = {
      selector: {
        footer: '.footer',
        stickyFooter: '.footer-top',
      },
      modifier: {
        sticky: 'footer-top--sticky',
      },
    };

    this.stickyFooter = document.querySelector(this.config.selector.stickyFooter);

    if (!this.stickyFooter) {
      return;
    }

    this.footer = document.querySelector(this.config.selector.footer);
    this.handleSticky((window.pageYOffset + window.innerHeight) > this.footer.offsetTop);
    this.bindEvents();
  }

  /**
   * Bind Events
   */
  bindEvents() {
    let lastPosition = 0;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking && lastPosition !== window.pageYOffset) {
        window.requestAnimationFrame(() => {
          this.handleSticky((window.pageYOffset + window.innerHeight) > this.footer.offsetTop);
          lastPosition = window.pageYOffset;
          ticking = false;
        });

        ticking = true;
      }
    });

    window.addEventListener('resize', debounce(() => {
      this.handleSticky((window.pageYOffset + window.innerHeight) > this.footer.offsetTop);
    }, 400));
  }

  /**
   * toggle footer stickyness
   * @param {boolean} fixed
   */
  handleSticky(fixed) {
    if (fixed) {
      this.stickyFooter.classList.remove(this.config.modifier.sticky);
    } else {
      this.stickyFooter.classList.add(this.config.modifier.sticky);
    }
  }
}
